import React from 'react';
import { Typography } from 'antd';
import {
  PRIMITIVE_AUTHORITY_FLAGS,
  type PrimitivePresentationState,
} from './primitiveSurfaceState';
import { PrimitiveSurfaceFrame } from './PrimitiveSurfaceFrame';
import styles from './primitives.module.css';

const { Text } = Typography;

export interface ResponsibilitySummaryProps {
  readonly presentationState: PrimitivePresentationState;
  readonly actorLabel?: string | null;
  readonly roleLabel?: string | null;
  readonly actingForLabel?: string | null;
  readonly grantsAuthority?: false;
  readonly grantsApproval?: false;
  readonly 'data-testid'?: string;
}

export function ResponsibilitySummary(props: ResponsibilitySummaryProps): React.ReactElement {
  const grantsAuthority = props.grantsAuthority ?? PRIMITIVE_AUTHORITY_FLAGS.grantsAuthority;
  const grantsApproval = props.grantsApproval ?? PRIMITIVE_AUTHORITY_FLAGS.grantsApproval;
  if (grantsAuthority !== false || grantsApproval !== false) {
    throw new Error('ResponsibilitySummary must keep grantsAuthority/grantsApproval=false');
  }

  return (
    <PrimitiveSurfaceFrame
      title="책임 요약"
      presentationState={props.presentationState}
      emptyMessage="책임 정보가 없습니다."
      data-testid={props['data-testid'] ?? 'responsibility-summary'}
      aria-label="책임 요약"
    >
      <div className={styles.primitiveStack}>
        <div className={styles.primitiveFieldRow}>
          <span className={styles.primitiveFieldLabel}>행위자</span>
          <Text>{props.actorLabel?.trim() ? props.actorLabel : '—'}</Text>
        </div>
        {props.roleLabel ? (
          <div className={styles.primitiveFieldRow}>
            <span className={styles.primitiveFieldLabel}>역할</span>
            <Text>{props.roleLabel}</Text>
          </div>
        ) : null}
        {props.actingForLabel ? (
          <div className={styles.primitiveFieldRow}>
            <span className={styles.primitiveFieldLabel}>대행</span>
            <Text type="secondary">{props.actingForLabel}</Text>
          </div>
        ) : null}
        <Text type="secondary">책임 표시는 인가(authorization)가 아닙니다.</Text>
      </div>
    </PrimitiveSurfaceFrame>
  );
}
